import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const ProductBCrumb = ({heading,bTitle,midTitle,allProductLink,pList,pcList,pcsList}) => {
  const navigate = useNavigate();

  const handleNav=(nm)=>{
    navigate(nm)
  }
  return (
    <React.Fragment>
      <div className="breadcrumb">
        <div className="container-lg container-fluid d-flex justify-content-center">
          <Row className="row">
            <Col lg={12}>
              <div className="section-title six pt-130 mb-50">
                <h2 className="text-center">{heading?heading.split("-").join(" "):""}</h2>
                <div className="breadcrumb-section ">
                  <div className="banner-wrapper">
                    <ul className="breadcrumb-list">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      {allProductLink && 
                      <li onClick={()=>handleNav(allProductLink.url)} style={{cursor:"pointer"}}>{allProductLink?allProductLink?.name?.split("-").join(" "):""}</li>
                      }
                      {pList && 
                      <li onClick={()=>handleNav(pList.url)} style={{cursor:"pointer"}}>{pList?pList?.name?.split("-").join(" "):""}</li>
                      }
                      {pcList &&
                      <li onClick={()=>handleNav(pcList.url)} style={{cursor:"pointer"}}>{pcList?pcList?.name?.split("-").join(" "):""}</li>
                      }
                      {pcsList &&
                      <li onClick={()=>handleNav(pcsList.url)} style={{cursor:"pointer"}}>{pcsList?pcsList?.name?.split("-").join(" "):""}</li>
                      }
                     
                    </ul>
                  </div>
                </div>
                <div className="mt-5">

                
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductBCrumb;
